<div class="messages-report">
  <app-page-title icon="fa-paper-plane" title="Mensagens Enviadas"></app-page-title>

  <div class="row" *ngIf="error">
    <div class="col">
      <p class="card gradient-row danger">{{ error }}</p>
    </div>
  </div>

  <form (submit)="search()">
    <div class="row">
      <div class="col-md-6">
        <app-month-picker [min]="minDate" [max]="maxDate" (monthAndYear)="onMonthAndYear($event)"></app-month-picker>
      </div>
    </div>
  </form>

  <app-skeleton *ngIf="loadingReport" variant="table-row" [count]="8" [columns]="3"
    label="Carregando o relatório de mensagens" data-testid="report-loading"></app-skeleton>

  <div *ngIf="!loadingReport && result?.length > 0; else notFound">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Data</th>
          <th>Quantidade de envios</th>
          <th>#</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let userCounter of result">
          <td>{{ userCounter.counter_date | date:"dd/MM/yyyy" }}</td>
          <td>{{ userCounter.quantity }}</td>
          <td>
            <a [routerLink]="['/messages-report', userCounter.counter_date]" *ngIf="userCounter.quantity > 0 && !userCounter.is_old; else noLink">
              <i class="fa fa-envelope" matTooltip="Visualizar SMS enviados do dia"></i>
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="text-end"><b>Total enviado:</b></td>
          <td colspan="2">{{ totalSent }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- `searchClicked` já segurava o vazio antes da primeira busca; o que faltava
       era segurá-lo DURANTE a consulta, que é quando ele mais engana. -->
  <ng-template #notFound>
    <div class="card" *ngIf="searchClicked && !loadingReport">
      Nenhuma mensagem enviada
    </div>
  </ng-template>

  <ng-template #noLink>
    <i class="fa fa-envelope disabled" matTooltip="Nenhum SMS enviado nesta data"></i>
  </ng-template>
</div>
